export interface AdminState {
  withoutScroll: boolean
}
export const DEFAULT_STATE: AdminState = {
  withoutScroll: false
};
